export default __webpack_public_path__ + "static/char-04-anr-5b745d8409b3ffc5dce8f71389a7481a.gif";